import { useContext } from 'react';
import type { UserProfile } from '../client';
import { AuthContext } from './auth-context';

/**
 * Access the current user profile. Returns null if not authenticated.
 *
 * @example
 * ```tsx
 * function Greeting() {
 *   const user = useUser();
 *   if (!user) return null;
 *   return <p>Hello, {user.firstName}!</p>;
 * }
 * ```
 */
export function useUser(): UserProfile | null {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useUser must be used within an <AuthProvider>');
  }
  return context.user;
}
